import type { ComponentPropsWithRef } from "react";
import { cx } from "./index";

/** Stroke icons on a 24-unit grid, drawn in `currentColor`. Decorative: the control carries the label. */
const PATHS = {
  inbox: "M3 13h5l1 3h6l1-3h5 M5 5h14l2 8v6H3v-6z",
  tasks: "M9 11l3 3 8-8 M20 12v7H4V5h11",
  chat: "M4 5h16v11H8l-4 4z",
  dashboard: "M4 4h7v7H4z M13 4h7v4h-7z M13 10h7v10h-7z M4 13h7v7H4z",
  approvals: "M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z M9 12l2 2 4-4",
  settings: "M4 6h10 M18 6h2 M4 12h4 M12 12h8 M4 18h12 M14 4v4 M8 10v4 M16 16v4",
  panel: "M3 4h18v16H3z M9 4v16",
  signOut: "M15 4h4v16h-4 M10 8l-4 4 4 4 M6 12h10",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M21 21l-5-5",
  compose: "M4 20h4L19 9l-4-4L4 16z M14 6l4 4",
  back: "M15 18l-6-6 6-6",
  reply: "M9 14 4 9l5-5 M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5V20",
  forward: "M15 14l5-5-5-5 M20 9H9.5A5.5 5.5 0 0 0 4 14.5V20",
  archive: "M3 4h18v4H3z M5 8v12h14V8 M10 12h4",
  trash: "M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14",
  snooze: "M12 7v5l3 2 M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",
  unsnooze: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M9 9l6 6 M15 9l-6 6",
  star: "M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z",
  unread: "M3 6h18v12H3z M3 6l9 7 9-7",
  more: "M5 12h.01 M12 12h.01 M19 12h.01",
  move: "M3 6h6l2 2h10v11H3z",
  tag: "M3 3h8l10 10-8 8L3 11z M7.5 7.5h.01",
  spam: "M12 3l9 16H3z M12 10v4 M12 17h.01",
  task: "M9 11l3 3 8-8 M20 12v7H4V5h11",
  share: "M4 12v7h16v-7 M12 3v12 M8 7l4-4 4 4",
  rule: "M13 3 5 14h6l-1 7 8-11h-6z",
  video: "M3 7h12v10H3z M15 10l6-3v10l-6-3",
  select: "M4 4h16v16H4z M8 12l3 3 5-6",
  send: "M4 12h14 M13 6l6 6-6 6",
  sent: "M3 11l18-8-7 18-2.5-7.5z M11.5 13.5 21 3",
  hash: "M5 9h14 M5 15h14 M10 4 8 20 M16 4l-2 16",
  newMessage: "M4 5h16v11H8l-4 4z M12 8v5 M9.5 10.5h5",
  calendar: "M4 6h16v14H4z M4 10h16 M8 3v4 M16 3v4",
  person: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21c1-4 4-6 8-6s7 2 8 6",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1 M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  lock: "M6 11h12v9H6z M8 11V8a4 4 0 0 1 8 0v3",
  status: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M8.5 12l2.5 2.5 4.5-5",
  cancel: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M6 6l12 12",
  reopen: "M4 12a8 8 0 1 0 2.3-5.7 M4 4v5h5",
  image: "M4 5h16v14H4z M4 16l5-5 4 4 2-2 5 5 M15 9h.01",
  bell: "M6 16v-5a6 6 0 0 1 12 0v5l2 2H4z M10 20h4",
  newsletter: "M4 5h13v14H6a2 2 0 0 1-2-2z M17 9h3v8a2 2 0 0 1-2 2 M7 9h7 M7 13h7",
  receipt: "M6 3h12v18l-3-2-3 2-3-2-3 2z M9 8h6 M9 12h6",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  eyeOff: "M3 3l18 18 M10.6 6.1A9 9 0 0 1 12 6c5 0 9 6 9 6a15 15 0 0 1-3 3.4 M6.6 6.6C4.3 8.1 3 12 3 12s4 6 9 6a8.8 8.8 0 0 0 4.4-1.2 M9.9 9.9a3 3 0 0 0 4.2 4.2",
  why: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.5V14 M12 17h.01",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, className, filled = false }: { name: IconName; className?: string | undefined; filled?: boolean | undefined }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={name === "more" ? 3 : 1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cx("size-[18px] shrink-0", className)}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}

/** A square icon-only button: `label` is its accessible name and its tooltip. */
/**
 * An icon button's colours, at rest and hovered. They live here, not in a caller's `className`:
 * `cx` only joins classes, so two colour utilities on one element are decided by their order in
 * the generated CSS, not by which came last (WP-048: a muted icon on the accent fill, 1.01:1).
 * Every pair is at least 4.5:1 in both themes (`ui/contrast.test.ts`).
 */
export const ICON_TONES = {
  plain: "text-muted hover:bg-surface-2 hover:text-text",
  /** On or pressed (a starred conversation). */
  active: "text-accent hover:bg-surface-2 hover:text-accent-strong",
  /** The screen's main action (compose, send). */
  primary: "bg-accent text-accent-contrast hover:bg-accent-strong",
} as const;
export type IconTone = keyof typeof ICON_TONES;

export function IconButton({
  icon,
  label,
  filled,
  tone = "plain",
  className,
  ...rest
}: Omit<ComponentPropsWithRef<"button">, "children" | "aria-label"> & {
  icon: IconName;
  label: string;
  filled?: boolean | undefined;
  tone?: IconTone;
  /** Size and spacing only; colours come from `tone`. */
  className?: string | undefined;
}) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={cx(
        "inline-grid size-9 shrink-0 place-items-center rounded-md transition-colors",
        ICON_TONES[tone],
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...rest}
    >
      <Icon name={icon} filled={filled} />
    </button>
  );
}
